<template>
<svg data-svg-lvl-2="cover-back" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 514 430">
<PreviewLayersCoverBackContourM27 :params="params" v-if="!params.isFlap7" />
<PreviewLayersCoverBackContourM27_F7 :params="params" v-if="params.isFlap7" />
<component :params="params" :is="`PreviewLayersCoverBackCorners${params.cornersBackComponent}`" v-if="params.cornersBackComponent" />
</svg></template>


<script>
/** Этот компонент генерируется автоматически, руками ничего менять нельзя!!! */
  
export default {props: { params: { type: Object, required: true, }, }, data() { return {} },}
</script>